module.exports = __webpack_public_path__ + "img/category-blazers.a90d7163.jpg";